/*
 * @Author: wuchenge
 * @Date:   2022-03-31 16:51:26
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-03-31 17:09:30
 */

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { http } from "utils/http";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Spinner from 'react-bootstrap/Spinner';

import { ListItem, ListInfo, LoadMore } from "../style";

const List = (props) => {
  const { search_label_ids, keyword } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [lastId, setLastId] = useState(0); // 分页最后一条
  const [list, setList] = useState([]); // 列表
  const [more, setMore] = useState(false); // 更多
  const preLastId = useRef(lastId)

  useEffect(() => {
    if(keyword == undefined) {
      return;
    }

    // 这里是用来比较是不是点击更多进来
    let paramId = 0;
    if(preLastId.current != lastId) {
      paramId = lastId;
    } 

    // 这里一定赋值，
    preLastId.current = lastId;

    setIsLoading(true);
    setLastId(paramId);
    http("/lists", {
      last_id: paramId,
      keyword: keyword,
      label_ids: search_label_ids,
    }).then((res) => {
      if (res.count > 10) {
        setMore(true);
      } else {
        setMore(false);
      }
      if (paramId > 0) {
        setList((pre, props) => {
          return [...pre, ...res.lists];
        });
      } else {
        setList(res.lists);
      }

      setIsLoading(false);
    });
  }, [lastId, search_label_ids, keyword]);

  // 点击更多
  const getMoreList = () => {
    setLastId(list[list.length - 1].id);
  };

  const load = <div style={{textAlign: "center"}}>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>

  return (
    <div>
      {isLoading && lastId == 0 ? load : null}
      {list?.map((item, index) => {
        return (
          <Link key={index} to={"/detail/" + item.id}>
          <Container>
            <Row style={{marginTop: "20px", color: "#333", borderBottom: "1px solid #ddd"}}>
              <Col lg={10} xs ={8}>
                <Row>{item.title}</Row>
                <Row>{item?.desc}</Row>
              </Col>
              <Col><Image src={item.thumb} style={{width: "80px", height: "80px", float: "right"}} rounded /></Col>
            </Row>
          </Container>
          </Link>
        );
      })}

      {more 
        ? isLoading ? load : <LoadMore onClick={() => getMoreList()}>更多...</LoadMore> 
        : <LoadMore>---触底了---</LoadMore>
      }
    </div>
  );
};

const mapState = (state) => ({
  keyword: state.getIn(["header", "keyword"]),
  search_label_ids: state.getIn(["home", "search_label_ids"]),
});

const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(List);
